'use client'

import Script from 'next/script'
import { useSyncExternalStore } from 'react'

// LOT FOR SALE's Google Analytics property (founder, 2026-10-23). Loaded only on the public domain, so local copies
// and the private preview never send traffic into the real reports.
const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || 'G-2WGT4H0SWQ'
const PUBLIC_HOSTS = new Set(['lotforsale.ph', 'www.lotforsale.ph'])
const noSubscribe = () => () => {}

export default function GoogleAnalytics() {
  // hostname never changes during a visit; false on the server so the tag is only added in the browser
  const onPublicHost = useSyncExternalStore(noSubscribe, () => PUBLIC_HOSTS.has(window.location.hostname), () => false)
  if (!GA_MEASUREMENT_ID || !onPublicHost) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  )
}
